import React from "react";
import { IconProps } from "./IconProps";

const CaretUpIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.18648 13.4246L9.5498 7.0613C9.60889 7.00214 9.67907 6.9552 9.75632 6.92318C9.83357 6.89116 9.91638 6.87467 10 6.87467C10.0836 6.87467 10.1664 6.89116 10.2437 6.92318C10.3209 6.9552 10.3911 7.00214 10.4502 7.0613L16.8135 13.4246C16.9329 13.544 17 13.706 17 13.8748C17 14.0437 16.9329 14.2056 16.8135 14.325C16.6941 14.4444 16.5322 14.5115 16.3633 14.5115C16.1945 14.5115 16.0325 14.4444 15.9131 14.325L10 8.41112L4.08689 14.325C4.02777 14.3841 3.95758 14.431 3.88033 14.463C3.80309 14.495 3.7203 14.5115 3.63669 14.5115C3.55307 14.5115 3.47028 14.495 3.39304 14.463C3.31579 14.431 3.2456 14.3841 3.18648 14.325C3.12736 14.2659 3.08046 14.1957 3.04846 14.1185C3.01647 14.0412 3 13.9584 3 13.8748C3 13.7912 3.01647 13.7084 3.04846 13.6312C3.08046 13.5539 3.12736 13.4837 3.18648 13.4246Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5812 12.8313C16.4934 12.919 16.3742 12.9684 16.25 12.9684C16.1258 12.9684 16.0066 12.919 15.9187 12.8313L10 6.9133L4.08125 12.8313C3.99239 12.9141 3.87486 12.9591 3.75342 12.957C3.63198 12.9549 3.51612 12.9057 3.43023 12.8198C3.34435 12.7339 3.29515 12.618 3.29301 12.4966C3.29087 12.3752 3.33595 12.2576 3.41875 12.1688L9.66875 5.91876C9.75664 5.83098 9.87578 5.78168 10 5.78168C10.1242 5.78168 10.2434 5.83098 10.3312 5.91876L16.5812 12.1688C16.669 12.2567 16.7183 12.3758 16.7183 12.5C16.7183 12.6242 16.669 12.7434 16.5812 12.8313Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.0306 15.5306C19.961 15.6004 19.8782 15.6557 19.7872 15.6934C19.6961 15.7312 19.5986 15.7506 19.5 15.7506C19.4014 15.7506 19.3038 15.7312 19.2128 15.6934C19.1217 15.6557 19.039 15.6004 18.9694 15.5306L12 8.56031L5.03061 15.5306C4.88988 15.6714 4.69901 15.7504 4.49999 15.7504C4.30097 15.7504 4.1101 15.6714 3.96936 15.5306C3.82863 15.3899 3.74957 15.199 3.74957 15C3.74957 14.801 3.82863 14.6101 3.96936 14.4694L11.4694 6.96937C11.539 6.89964 11.6217 6.84432 11.7128 6.80658C11.8038 6.76883 11.9014 6.7494 12 6.7494C12.0986 6.7494 12.1961 6.76883 12.2872 6.80658C12.3782 6.84432 12.461 6.89964 12.5306 6.96937L20.0306 14.4694C20.1003 14.539 20.1557 14.6217 20.1934 14.7128C20.2312 14.8038 20.2506 14.9014 20.2506 15C20.2506 15.0986 20.2312 15.1962 20.1934 15.2872C20.1557 15.3782 20.1003 15.461 20.0306 15.5306Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_556_7513)">
            <path
              d="M26.53 20.53C26.3894 20.6705 26.1988 20.7494 26 20.7494C25.8012 20.7494 25.6106 20.6705 25.47 20.53L16 11.0613L6.53 20.53C6.38782 20.6625 6.19978 20.7346 6.00548 20.7312C5.81118 20.7278 5.62579 20.649 5.48838 20.5116C5.35096 20.3742 5.27225 20.1888 5.26882 19.9945C5.2654 19.8002 5.33752 19.6122 5.47 19.47L15.47 9.47001C15.6106 9.32956 15.8012 9.25067 16 9.25067C16.1987 9.25067 16.3894 9.32956 16.53 9.47001L26.53 19.47C26.6705 19.6106 26.7493 19.8013 26.7493 20C26.7493 20.1988 26.6705 20.3894 26.53 20.53Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath>
              <rect width="32" height="32" fill={color} />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export default CaretUpIcon;
